export function bFileReaderDirective() {
  'ngInject';

  let directive = {
    restrict: 'A',
    require: '?ngModel',
    link: fileReaderLink
  };

  return directive;
}

function fileReaderLink(scope, element, attrs, ngModel){
  if( attrs.type === 'file' && ngModel ) {
    element.bind('click', function () {
      this.value = '';
    });
    element.bind('change', function(event) {
      scope.$apply(function() {
        ngModel.$setViewValue(event.target.files);
      });
    });
  }
}
